import {
  HeadlineH4BoldCSS,
  HeadlineH6BoldCSS
} from '@nect/ui/component/headline/headline.styled';
import {
  TextBodySmallCSS,
  TextButtonMediumCSS
} from '@nect/ui/component/text/text.styled';
import { Color } from '@nect/ui/theme/color';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface FaqImageTextProps {
  isCorrect?: boolean;
}
interface ImageCheckboxProps {
  isTick?: boolean;
}
interface FaqImageBoxProps {
  lang?: string;
}

const ContainerMain = styled.div`
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  max-width: 830px;
  @media (min-width: 768px) {
    min-width: 798px;
  }
  padding-top: 40px;
  flex-grow: 1;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 383px;
  flex: 1;
`;

const Card = styled(Link)`
  border: 1px solid ${(props: any) => props.theme.grayLight};
  box-sizing: border-box;
  border-radius: 8px;
  width: 373px;
  height: auto;
  margin-top: 24px;
  margin-bottom: 32px;
  padding: 24px;
  background: white;
  align-items: flex-start;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  :hover {
    background: ${(props: any) => props.theme.blueLight};
    border: 1px solid ${(props: any) => props.theme.blueLight};
    box-shadow: 0px 8px 20px ${(props: any) => props.theme.blueLightShadow};
  }
`;

const CardGray = styled.div`
  border: 1px solid ${(props: any) => props.theme.grayButton};
  box-sizing: border-box;
  border-radius: 8px;
  width: 376px;
  margin-top: 10px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  background: ${(props: any) => props.theme.grayButton};
  padding: 10px;
  @media (max-width: 620px) {
    width: 200px;
  }
`;

const FaqImageWrapper = styled.div`
  display: flex;
  border: 1px solid #dddee0;
  border-radius: 8px;
  margin-top: 24px;
  justify-content: space-around;
  max-height: 320px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-height: none;
    align-items: center;
  }
`;

const FaqImageBox = styled.div<FaqImageBoxProps>`
  height: 228px;
  width: 200px;
  border-radius: 8px;
  margin: 16px 0
    ${(props: any) =>
      props.lang === 'es' || props.lang === 'pl' ? '70px' : '50px'};
  position: relative;
  z-index: -1;
`;

const FaqImage = styled.img`
  width: 200px;
  height: 228px;
  border-radius: 8px;
`;

const FaqImageText = styled.p<FaqImageTextProps>`
  color: ${(props: any) => (props.isCorrect ? '#11c6b0' : '#F01C4F')};
  margin-top: 10px;
  text-align: center;
  letter-spacing: 0.02em;
`;

const FaqImageCheckmarkBox = styled.div<ImageCheckboxProps>`
  background: ${(props: any) => (props.isTick ? '#11c6b0' : '#F01C4F')};
  border-radius: 20px;
  height: 20px;
  width: 20px;
  display: grid;
  align-items: center;
  position: absolute;
  bottom: -10px;
  right: -10px;
  justify-items: center;
`;

const FaqImageCheckmark = styled.div`
  transform: rotate(45deg);
  height: 11px;
  width: 6px;
  border-bottom: 0.15em solid #ffffff;
  border-right: 0.15em solid #ffffff;
  margin-bottom: 2px;
`;

const FaqImageCheckmarkCross = styled.div`
  width: 100%;
  height: 100%;
  right: 6px;
  position: absolute;
  top: 4px;

  :before,
  :after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 12px;
    width: 2px;
    background-color: #ffffff;
  }

  :before {
    transform: rotate(45deg);
  }

  :after {
    transform: rotate(-45deg);
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 620px) {
    flex-direction: column;
  }
`;

const GifGreen = styled.img`
  border: 2px solid ${(props: any) => props.theme.primary};
  box-sizing: border-box;
  border-radius: 8px;
  width: 140px;
  height: 137px;
  object-fit: cover;
`;

const GifRed = styled.img`
  border: 2px solid transparent;
  box-sizing: border-box;
  border-radius: 8px;
  width: 140px;
  height: 137px;
  object-fit: cover;
`;

const GifTitleGreen = styled.p`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${(props: any) => props.theme.primary};
  text-align: center;
`;

const GifTitleGray = styled.p`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${(props: any) => props.theme.grey};
  text-align: center;
`;

const TitlePage = styled.p`
  width: 100%;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 54px;
  color: ${(props: any) => props.theme.black};
  text-align: left;
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 27px;
  }
`;

const Answer = styled.p`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.black};
  text-align: left;
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 23px;
  }
  b {
    color: ${(props: any) => props.theme.primary};
    font-weight: normal;
  }
  a {
    display: inline;
    color: ${(props: any) => props.theme.color[Color.nectGreen500]};
    text-decoration: underline;
  }
`;

const Title = styled.p`
  width: 100%;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.02em;
  color: ${(props: any) => props.theme.black};
  text-align: left;
  margin-top: 40px;
  scroll-margin-top: 100px;

  ${HeadlineH4BoldCSS}

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 27px;
  }
`;

const SubTitle = styled.p`
  width: 100%;
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.04em;
  color: ${(props: any) => props.theme.charcoal};
  text-align: left;
  margin-bottom: 40px;
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 27px;
    margin-bottom: 16px;
  }
  b {
    color: ${(props: any) => props.theme.primary};
  }
  a {
    display: inline;
    color: ${(props: any) => props.theme.color[Color.nectGreen500]};
    text-decoration: underline;
  }
`;

const MessageCard = styled.p`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.04em;
  ${TextBodySmallCSS}
  color: #4B4F55;
  margin-top: 8px;
  padding: 0px;
  margin-right: 10px;
  text-align: left;
`;

const Image = styled.img`
  max-width: 757px;
  margin-top: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 620px) {
    max-width: 292px;
  }
`;

const CardBlue = styled(Link)`
  background: ${({ theme }) => theme.color[Color.snackInfoPad]};
  box-sizing: border-box;
  border-radius: 4px;
  width: 804px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    width: 100%;
    max-height: 59px;
  }
  :hover {
    background: ${(props: any) => props.theme.white};
    box-shadow: 0px 8px 20px ${(props: any) => props.theme.blueLight};
  }
  -webkit-tap-highlight-color: transparent;
`;

const TitleCardBlue = styled.p`
  width: 100%;
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-size: 18px;
  font-weight: bold;
  line-height: 27px;
  letter-spacing: 0.02em;
  ${HeadlineH6BoldCSS}
  color: ${({ theme }) => theme.color[Color.snackInfoBase]};
  text-align: left;
  align-self: center;
`;

const IconCardBlue = styled.img`
  margin: 24px;
  align-self: start;
  @media (max-width: 620px) {
    margin: 16px;
  }
`;

const ButtonGray = styled(Link)`
  background: ${(props: any) => props.theme.grayButton};
  border: 15px solid ${(props: any) => props.theme.grayButton};
  box-sizing: border-box;
  border-radius: 4px;
  height: 44px;
  color: ${(props: any) => props.theme.black};
  font-family: Heebo, sans-serif;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.02em;
  cursor: pointer;
  :hover {
    background: ${(props: any) => props.theme.grayLight};
    border: 15px solid ${(props: any) => props.theme.grayLight};
  }
  -webkit-tap-highlight-color: transparent;
`;

const BlueButtonLink = styled(Link)`
  background-color: ${(props: any) => props.theme.blue};
  font-size: 0.7rem;
  line-height: 0.85rem;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 40px;
  padding-right: 40px;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${TextButtonMediumCSS}
  color: ${(props: any) => props.theme.white};
`;

const NavigationMainContainer = styled.div`
  position: fixed;
  left: 0%;
  background: ${(props: any) => props.theme.white};
  border-bottom: 0.5px solid ${(props: any) => props.theme.grayLight};
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    top: 75px;
  }
`;

const NavigationContainer = styled.div`
  width: 830px;
  display: flex;
  flex-direction: row;
  padding-top: 16px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
    padding-left: 25px;
  }
`;

const PartnerErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  margin-top: 40px;
`;

const NavigationText = styled(Link)`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${(props: any) => props.theme.charcoal};
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  margin-left: 8px;
  @media (max-width: 768px) {
    font-size: 13px;
  }
  :hover {
    text-decoration: underline;
  }
`;

const ContentContainer = styled.div`
  border: 1px solid ${(props: any) => props.theme.grayLight};
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  padding: 24px;
  margin-bottom: 48px;
  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 24px;
  }
`;

const ImageNavigation = styled.img`
  height: 24px;
  width: 24px;
  @media (max-width: 768px) {
    height: 16px;
    width: 16px;
    padding-top: 5px;
  }
  @media (max-width: 855px) {
    padding-left: 16px;
  }
`;

const Divider = styled.div`
  padding-left: 8px;
  padding-top: 3px;
`;

const Question = styled.p`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 31px;
  letter-spacing: 0.04em;
  margin-bottom: 24px;
  width: 100%;
  color: ${(props: any) => props.theme.black};
  @media (max-width: 768px) {
    margin-bottom: 16px;
    font-size: 18px;
    text-align: left;
  }
  b {
    color: ${(props: any) => props.theme.primary};
  }
`;

const Box = styled.div`
  padding: 32px;
  border-radius: 8px;
  background-color: #edf7fb;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 30px;
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

const BoxTitle = styled.h2`
  font-size: 1rem;
  font-family: Poppins, sans-serif;
  font-weight: bold;
  line-height: 1.5rem;
  margin: 0;
  margin-bottom: 8px;
  margin-top: 8px;
  ${HeadlineH6BoldCSS}
  color: ${(props: any) => props.theme.black};
`;

const BoxMessage = styled.p`
  font-family: Heebo, sans-serif;
  font-size: 13px;
  line-height: 150%;
  letter-spacing: 0.04em;
  margin-top: 4px;
  padding-top: 0px;
  ${TextBodySmallCSS}
  color: ${(props: any) => props.theme.black};
  @media (max-width: 768px) {
    text-align: left;
  }

  > a {
    display: inline-block;
    color: #2f80ed;
    text-decoration: underline;
  }
`;

const BlueButtonContainer = styled.div`
  align-self: center;
  margin-top: 24px;
`;

interface TabProps {
  selected: boolean;
}

const Tab = styled.div<TabProps>`
  width: 117px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
  background: ${(props: any) =>
    props.selected ? props.theme.grayButton : props.theme.white};
  border-color: ${(props: any) =>
    props.selected ? props.theme.grayButton : props.theme.grayLight};
  @media (max-width: 620px) {
    margin-top: 15px;
    width: 65px;
    border-radius: 8px;
    border: 1px solid;
  }
  &:hover {
    background: ${(props: any) =>
      !props.selected ? props.theme.grayLight : ''};
  }
`;

const TabTitle = styled.h4`
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  display: flex;
  margin-left: 8px;
  align-items: center;
  letter-spacing: 0.02em;
  color: ${(props: any) => props.theme.black};
`;

export const FaqStyled = {
  Title,
  GifGreen,
  SubTitle,
  TitleCardBlue,
  ButtonGray,
  Container,
  ContainerMain,
  Card,
  MessageCard,
  CardContainer,
  CardsContainer,
  CardBlue,
  IconCardBlue,
  PartnerErrorContainer,
  NavigationMainContainer,
  ImageNavigation,
  Divider,
  ContentContainer,
  Question,
  BlueButtonLink,
  Image,
  TitlePage,
  Answer,
  ButtonContainer,
  CardGray,
  FaqImageWrapper,
  FaqImage,
  FaqImageCheckmarkBox,
  FaqImageCheckmark,
  FaqImageCheckmarkCross,
  FaqImageBox,
  FaqImageText,
  GifRed,
  GifTitleGreen,
  GifTitleGray,
  Box,
  BoxTitle,
  BoxMessage,
  BlueButtonContainer,
  Tab,
  TabTitle,
  NavigationContainer,
  NavigationText
};
